import { smartProps } from "@smartfire/gutenberg-react";
import React from "react";

export default class BackgroundGrid extends React.Component {
  static smartProps = {
    color: smartProps.any.withDefault("grey"),
    width: smartProps.any.withDefault(100),
    height: smartProps.any.withDefault(100),
    top: smartProps.any.withDefault(0),
    left: smartProps.any.withDefault(0),
  };

  render() {
    return (
      <div
        className={"background-grid " + this.props.color}
        style={{
          width: this.props.width + "%",
          height: this.props.height + "%",
          top: this.props.top + "px",
          left: this.props.left + "%",
        }}
      >
        <div className="line top"></div>
        <div className="line bottom"></div>
        <div className="line left"></div>
        <div className="line right"></div>
      </div>
    );
  }
}
